'use strict';
class Bazaarvoice {
  constructor() {
    this.container = document.querySelector('.product-bottom-ratings [data-bv-show="reviews"]');
    if (!this.container) return;
    this.watchReviewWidgetInitialization();
  }

  watchReviewWidgetInitialization() {
    const viewportHeight = Math.floor((window.innerHeight * 10) / 100) + 'px';
    const config = {
      root: null,
      rootMargin: '0px 0px 0' + viewportHeight + ' 0px',
      threshold: 0.05,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        const section = entries[0].target;
        observer.unobserve(section);
        setTimeout(this.init.bind(this), 1000);
      }
    }, config);

    observer.observe(this.container);
  }

  init() {
    this.root = this.container.shadowRoot;
    if (!this.root) return;
    this.shouldWatchForGuidelineModal = true;
    this.guidelineModalObserver = null;
    this.updateReviewWidgetStyle();
    this.watchReviewWidgetChanges();
  }

  watchReviewWidgetChanges() {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = window.debounce((mutationList, observer) => {
      mutationList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (mutation.addedNodes.length === 0) return;
          Array.from(mutation.addedNodes).every((node) => {
            if (node.id && node.id === 'bv-rnr-portal') {
              this.updatePhotoModal(node);
              return false;
            }
          });
        }

        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-pressed') {
          const starBtnParent = mutation.target.closest('.bv_rating_content3');
          if (!starBtnParent) return;
          const addReviewModal = document.querySelector('[data-bv-show="inpage_submission"]');
          setTimeout(() => this.updateAddReviewModalStyle(), 1000);
          // else this.watchReviewModalsInjectedToDOM();
        }
      });
    });

    const observer = new MutationObserver(callback);
    observer.observe(this.root, config);
    // observer.disconnect();
  }

  watchReviewModalsInjectedToDOM() {
    let isBvAddReviewModalInjected = false;
    const rootElem = document.body;
    const config = { attributes: false, childList: true, subtree: false };
    const callback = window.debounce((mutationList, observer) => {
      mutationList.every((mutation) => {
        Array.from(mutation.addedNodes).every((added_node) => {
          const bvshow = added_node?.dataset?.bvShow;
          if (bvshow && bvshow === 'inpage_submission') {
            isBvAddReviewModalInjected = true;
            setTimeout(() => {
              this.updateAddReviewModalStyle(added_node);
            }, 1000);
            observer.disconnect();
            return false;
          }

          return true;
        });

        if (isBvAddReviewModalInjected) {
          observer.disconnect();
          return false;
        }

        return true;
      });
    });

    const observer = new MutationObserver(callback);
    observer.observe(rootElem, config);
  }

  watchReviewGuidLineModalChanges(addReviewModal) {
    if (!addReviewModal) return;

    // const modal = addReviewModal.querySelector('[role="dialog"][type="main"]');
    // if(!modal) return;

    let stopLooping = false;
    const config = { attributes: false, childList: true, subtree: true };
    const callback = window.debounce((mutationList, observer) => {
      mutationList.every((mutation) => {
        if (mutation.type === 'childList') {
          Array.from(mutation.addedNodes).every((node) => {
            if (!node || !node.getAttribute) return true;

            const type = node.getAttribute('type');
            const hiddenElem = node.querySelector('[aria-hidden="true"]');
            const dialog = node.querySelector('[role="dialog"]');

            if (type && type === 'popup' && dialog) {
              const dialogLabel = dialog.getAttribute('aria-labelledby');
              if (hiddenElem) hiddenElem.removeAttribute('aria-hidden');

              let closeBtnParent = node.querySelector('#bv-ips-label-close-button');
              if (dialogLabel && dialogLabel === 'bv-ips-successpop-popup')
                closeBtnParent = node.querySelector('button[aria-label*="Close"]');

              if (dialog && closeBtnParent) dialog.prepend(closeBtnParent.parentElement);
              _theme.focusFirstTabbable($(node));
              this.shouldWatchForGuidelineModal = false;
              stopLooping = true;

              return false; // to stop looping
            }

            return true;
          });

          Array.from(mutation.removedNodes).every((node) => {
            if (!node || !node.getAttribute) return true;
            const type = node.getAttribute('type');
            const hiddenElem = node.querySelector('[aria-hidden="true"]');
            if (type && type === 'popup' && hiddenElem) {
              this.shouldWatchForGuidelineModal = true;
              stopLooping = true;
              return false; // to stop looping
            }
            return true;
          });
        }

        if (stopLooping) return false;

        return true;
      });
    });

    this.guidelineModalObserver = new MutationObserver(callback);
    this.guidelineModalObserver.observe(addReviewModal, config);
  }

  updateReviewWidgetStyle() {
    const style = document.createElement('style');
    style.textContent = `
            .visually-hidden {
                position: absolute!important;
                overflow: hidden;
                width: 1px;
                height: 1px;
                margin: -1px;
                padding: 0;
                border: 0;
                clip: rect(0 0 0 0);
                word-wrap: normal!important;
            }
            ul li .prev, .cTWDsX li .next { position: relative; }
            ul li .prev:focus::after, ul li .prev:focus-visible::after,
            ul li .prev:hover::after { content: 'Previous reviews'; left: 0; }
            ul li .next:focus::after, ul li .next:focus-visible::after,
            ul li .next:hover::after { content: 'Next reviews'; right: 0; }
            ul li .prev:focus::after, ul li .prev:focus-visible::after, ul li .prev:hover::after,
            ul li .next:focus::after, ul li .next:focus-visible::after, ul li .next:hover::after {
                display: block;
                background: #000;
                color: #fff;
                position: absolute;
                top: calc(100% + 4px);
                padding: 4px 8px;
                font-size: 0.875rem;
                line-height: normal;
                white-space: nowrap;
            }
            #bv_review_maincontainer svg.cFbpKl path, 
            #bv_review_maincontainer svg.cFbpKl polygon { stroke: #000;}
            .cWOpu .reportbutton { border: 1px solid #000; padding: 4px 8px;}
            button.jqywFD { text-decoration: underline; }
            .jXqgwC { padding: 6px 10px !important; }
            .bv-reviews-product-rating-star {
                padding: 2.5px !important;
            }
        `;
    this.root.append(style);

    const snapshotHeading = this.root.querySelector('#bv-reviews-rating-snapshot-container');
    const snapshotHeadingSr = this.root.querySelector(
      '#bv-reviews-rating-snapshot-container .visually-hidden'
    );
    if (snapshotHeading && !snapshotHeadingSr) {
      const snapshotHeadingSrText = document.createElement('span');
      snapshotHeadingSrText.classList.add('visually-hidden');
      snapshotHeadingSrText.textContent = 'snapshot';
      snapshotHeading.append(snapshotHeadingSrText);
    }

    const allSvgRepeatedIdElems = this.root.querySelectorAll(
      '[id="bv_rating_summary_star_filled_1_1_99.99_product1_undefined"]'
    );
    allSvgRepeatedIdElems.forEach((elem, index) => {
      const newId = elem.id + '_' + index;
      elem.id = newId;
      const svg = elem.closest('svg');
      if (!svg) return;
      const svg_polygon = svg.querySelector('polygon');
      const svg_path = svg.querySelector('path');
      const newStyle = `url(${window.location.href}#${newId})`;
      if (svg_polygon) svg_polygon.style.fill = newStyle;
      if (svg_path) svg_path.style.fill = newStyle;
    });
  }

  updatePhotoModal(target) {
    if (!target) return;
    const photoModal = target.querySelector('#photoModal');
    if (!photoModal) return;
    // _theme.focusFirstTabbable($(photoModal));
    photoModal.setAttribute('aria-label', 'Full Review');
    const closeBtn = photoModal.querySelector('.modalCloseBtn');
    // const sliderArrowBtns = photoModal.querySelectorAll('.daYmlv button');

    const roleAlertImgs = photoModal.querySelectorAll('img[role="alert"]');
    roleAlertImgs.forEach((img) => {
      img.removeAttribute('role');
      img.removeAttribute('aria-live');
    });

    // if(sliderArrowBtns.length > 0){
    //     sliderArrowBtns[0].querySelector('span').textContent = 'View previous image';
    //     sliderArrowBtns[1].querySelector('span').textContent = 'View next image';
    // }

    if (closeBtn) {
      const btnSrOnlyText = document.createElement('span');
      btnSrOnlyText.classList.add('visually-hidden');
      const btnText = 'Close photo modal';
      btnSrOnlyText.textContent = btnText;
      closeBtn.append(btnSrOnlyText);
      closeBtn.setAttribute('aria-label', btnText);
    }
  }

  updateAddReviewModalStyle(addReviewModal) {
    const reviewModal =
      addReviewModal || document.querySelector('[data-bv-show="inpage_submission"]');
    if (!reviewModal || !reviewModal.shadowRoot) return;
    const root = reviewModal.shadowRoot;
    const isStyleExist = root.querySelector('style[data-new]');
    if (this.shouldWatchForGuidelineModal) {
      if (this.guidelineModalObserver) {
        this.guidelineModalObserver.disconnect();
        this.guidelineModalObserver = null;
      }
      setTimeout(() => {
        this.watchReviewGuidLineModalChanges(root);
      }, 2000);
    }

    if (isStyleExist) return;
    const style = document.createElement('style');
    style.setAttribute('data-new', true);
    style.textContent = `
            .ckUDTq {white-space: normal;}
            [type="fieldTitle"] button {text-decoration: underline;}
            [type="focus"] [aria-labelledby*='bv-ips-offscreen-round-close-button'] { height: auto; }
        `;
    root.append(style);
  }
}

window.addEventListener('DOMContentLoaded', (evt) => {
  new Bazaarvoice();
});
